import * as React from 'react';
/**
 * Context which holds the navigation prop for a screen.
 */
const NavigationContext = /*#__PURE__*/React.createContext(undefined);
export default NavigationContext;
//# sourceMappingURL=NavigationContext.js.map